module.exports = __webpack_public_path__ + "static/media/github.1b8839e5.png";